module.exports = __webpack_public_path__ + "img/martinhal-lisbon-chiado.2e9e55c7.jpg";